import { render, staticRenderFns } from "./examenv2-test.vue?vue&type=template&id=4e55c4ec&"
import script from "./examenv2-test.vue?vue&type=script&lang=js&"
export * from "./examenv2-test.vue?vue&type=script&lang=js&"
import style0 from "./examenv2-test.vue?vue&type=style&index=0&id=4e55c4ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports